export const TabletTouchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path d="M21.5.5H4.5v17h17a2,2,0,0,0,2-2V2.5A2,2,0,0,0,21.5.5Z" fill="#00C4B8" />
      <path d="M21.86.531A2.034,2.034,0,0,0,21.5.5H4.5v17h.393Z" fill="#c4f0eb" />
      <path d="M4.5.5h-2a2,2,0,0,0-2,2v13a2,2,0,0,0,2,2h2Z" fill="#ffffff" />
      <path
        d="M6.5,17.5h-4a2,2,0,0,1-2-2V2.5a2,2,0,0,1,2-2h19a2,2,0,0,1,2,2V15"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={4.5}
        y1={17.499}
        x2={4.5}
        y2={0.499}
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.75,8.749h0A.249.249,0,0,1,3,9H3a.25.25,0,0,1-.25.25h0A.25.25,0,0,1,2.5,9h0a.249.249,0,0,1,.25-.25"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.653,23.5,8.847,18.921A1.5,1.5,0,0,1,11.154,17L13.5,19.826V10a1.5,1.5,0,0,1,3,0v6.5h3a4,4,0,0,1,4,4v3"
        fill="#c4f0eb"
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={21.5}
        y1={7.499}
        x2={21.5}
        y2={10.499}
        stroke="#00303e"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
